<template>
    <q-banner :class="bannerClass" inline-actions>
        <!-- Avatar -->
        <template v-slot:avatar>
            <q-icon :name="icon" color="white" size="md" />
        </template>

        <!-- Message -->
        {{ message }}

        <!-- Actions -->
        <template v-slot:action>
            <q-btn
                v-if="showDismiss"
                @click="$emit('dismiss')"
                :label="$t('Dismiss')"
                color="white"
                flat
            />
            <q-btn
                v-if="action"
                @click="performAction"
                :label="actionLabelWithDefault"
                :loading="isLoading"
                color="white"
                flat
            />
        </template>
    </q-banner>
</template>

<script>
export default {
    name: 'AnnouncementBanner',
    emits: ['dismiss'],
    props: {
        icon: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        action: {
            type: Function,
            required: false,
            default: null
        },
        actionLabel: {
            type: String,
            required: false,
            default: ''
        },
        showDismiss: {
            type: Boolean,
            required: false,
            default: true
        },
        level: {
            type: String,
            default: 'error',
            validator: value =>
                ['error', 'warning', 'info', 'success'].includes(value)
        }
    },
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        /**
         * Provide a default value for action label, with reactive translation
         * @return {String} Action label
         */
        actionLabelWithDefault() {
            return this.actionLabel ? this.actionLabel : this.$t('Reconnect');
        },
        /**
         * Provide a default value for banner color, based on level
         * @return {Object} CSS classes
         */
        bannerClass() {
            return {
                'text-white': true,
                'bg-red': this.level === 'error',
                'bg-orange': this.level === 'warning',
                'bg-blue': this.level === 'info',
                'bg-green': this.level === 'success'
            };
        }
    },
    methods: {
        /**
         * Trigger reconnect function.
         */
        async performAction() {
            this.isLoading = true;
            await this.action()
                .catch(error => {
                    console.error('Failed to perform action due to: ', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.q-banner {
    // Add a subtle white line beneath each banner
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
</style>
